import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry, SentryErrorBoundary } from "./lib/sentry";
import { initAnalytics } from "./lib/cookieConsent";
import App from "./App.tsx";
import "./index.css";

// Initialiser Sentry EN PREMIER (avant tout autre code)
initSentry();

// Initialiser Clarity seulement si le consentement cookies a été accepté
initAnalytics();

// Utilitaire de reset checklist pour les tests (accessible via window.resetB8ildChecklist())
import "./utils/resetChecklistForTesting";

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => { if (import.meta.env.DEV) console.log('[SW] Registration successful:', registration.scope); },
      (error) => console.error('[SW] Registration failed:', error)
    );
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold mb-4">Une erreur est survenue</h1>
            <p className="text-slate-400 mb-6">
              Nous avons été notifiés et travaillons à résoudre le problème.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg"
            >
              Recharger la page
            </button>
          </div>
        </div>
      }
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>
);
